import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  getGaMeasurementId,
  initGoogleAnalytics,
  trackGaPageView,
} from '../lib/googleAnalytics.js';

/** Carga gtag.js y envía page_view en cada cambio de ruta (sitio público). */
export function useGoogleAnalytics() {
  const { pathname, search } = useLocation();
  const measurementId = getGaMeasurementId();

  useEffect(() => {
    if (!measurementId) return;
    initGoogleAnalytics(measurementId);
  }, [measurementId]);

  useEffect(() => {
    if (!measurementId || pathname.startsWith('/admin')) {
      return;
    }
    trackGaPageView(pathname + search, measurementId);
  }, [pathname, search, measurementId]);
}
